import { Box, Skeleton } from '@mui/material';
import { Container } from '../../../components/container';

export const DocumentsSkeleton = () => (
  <Container>
    <Box sx={{ mb: 4 }}>
      <Skeleton variant="text" width={200} height={40} />
    </Box>

    <Box sx={{ mb: 3 }}>
      <Box sx={{ display: 'flex', gap: 2, mb: 3, borderBottom: 1, borderColor: 'divider', pb: 1 }}>
        <Skeleton variant="text" width={120} height={32} />
        <Skeleton variant="text" width={100} height={32} />
      </Box>

      <Box sx={{ py: 3 }}>
        <Skeleton variant="text" width={250} height={36} sx={{ mb: 3 }} />
        <Skeleton variant="text" width="100%" height={24} sx={{ mb: 2 }} />
        <Skeleton variant="text" width="95%" height={24} sx={{ mb: 2 }} />
        <Skeleton variant="text" width="98%" height={24} sx={{ mb: 2 }} />
        <Skeleton variant="text" width="90%" height={24} sx={{ mb: 3 }} />

        <Skeleton variant="text" width={220} height={28} sx={{ mb: 2 }} />
        <Skeleton variant="text" width="100%" height={24} sx={{ mb: 2 }} />
        <Skeleton variant="text" width="93%" height={24} sx={{ mb: 2 }} />
        <Skeleton variant="text" width="97%" height={24} sx={{ mb: 3 }} />

        <Skeleton variant="text" width={220} height={28} sx={{ mb: 2 }} />
        <Skeleton variant="text" width="100%" height={24} sx={{ mb: 2 }} />
        <Skeleton variant="text" width="88%" height={24} sx={{ mb: 2 }} />
        <Skeleton variant="text" width="95%" height={24} sx={{ mb: 2 }} />
        <Skeleton variant="text" width="92%" height={24} />
      </Box>
    </Box>
  </Container>
);
